import { FC, useEffect, useState } from "react";
import { notify } from "../notification";
import { ApiVideoTocApi, Configuration } from "../../generated/api";
import { isResponseError } from "../../lib/isResponseError";
import { getActiveModelErrorMessage } from "../../lib/getActiveModelErrorMessage";

interface Props {
  location?: { reload: () => void };
  csrfToken: string;
  videoId: number;
  tocGenerating?: boolean;
}

export const VideoTocGenButton: FC<Props> = ({
  location = window.location,
  ...props
}) => {
  const [isGenerating, setIsGenerating] = useState(
    props.tocGenerating || false
  );

  useEffect(() => {
    if (!props.tocGenerating) {
      return;
    }
    const intervalId = setInterval(() => {
      const api = new ApiVideoTocApi(
        new Configuration({
          basePath: "",
          headers: {
            "x-hopper-api-version": "1.0",
            "X-CSRF-Token": props.csrfToken,
          },
        })
      );
      api
        .apiVideoVideoIdTocLatestGenerationHistoryGet({
          videoId: props.videoId,
        })
        .then((data) => {
          if (data.state === "completed") {
            location.reload();
          } else if (data.state === "failed") {
            notify("AIによる目次生成に失敗しました。");
            location.reload();
          }
        })
        .catch((error) => {
          console.error("Error fetching TOC generation status:", error);
          notify(
            "目次の生成ステータスの取得に失敗しました。もう一度試してください。"
          );
        });
    }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, [location, props.csrfToken, props.tocGenerating, props.videoId]);

  const handleGenerateToc = async () => {
    setIsGenerating(true);

    try {
      const api = new ApiVideoTocApi(
        new Configuration({
          basePath: "",
          headers: {
            "x-hopper-api-version": "1.0",
            "X-CSRF-Token": props.csrfToken,
          },
        })
      );
      await api.apiVideoVideoIdTocAddGenerateJobPost({
        videoId: props.videoId,
      });
      location.reload();
    } catch (reason) {
      setIsGenerating(false);

      let msg =
        "エラーが発生しました。画面をリロードしてもう一度試してください。";
      if (isResponseError(reason) && reason.response.status === 422) {
        msg = await getActiveModelErrorMessage(reason.response, msg);
      }
      alert(msg);
      Rollbar.info(reason, msg);
    }
  };

  return (
    <button
      className="c-button--text no-padding"
      onClick={handleGenerateToc}
      disabled={isGenerating}
    >
      {isGenerating ? "目次を生成中..." : "AIで目次を生成"}
    </button>
  );
};
export default VideoTocGenButton;
